import React, {ComponentPropsWithoutRef, FC} from 'react';

import {ProgressCollapsedDots} from '@/components/ui/ProgressCollapsedDots/ProgressCollapsedDots';
import {calculateVisibleElements} from '@/services/loyalty/progressUtils';
import stringUtils from '@/utils/stringUtils';
import {twx} from '@/utils/tailwindUtils';

interface IProgressProps extends ComponentPropsWithoutRef<'div'> {
    title: string;
    currentStep: number;
    totalSteps: number;
}

export const Progress: FC<IProgressProps> = ({title, currentStep, totalSteps, ...rest}) => {
    const areTotalStepsValid = totalSteps > 0 && !isNaN(totalSteps);

    if (!areTotalStepsValid || !title) {
        return null;
    }

    const {visibleCircles, collapsedEnd, collapsedStart} = calculateVisibleElements(totalSteps, currentStep);

    return (
        <div className='flex w-full flex-col gap-2' {...rest}>
            <span className='text-14 font-bold leading-143 text-romance'>
                {stringUtils.formatString(title, currentStep, totalSteps)}
            </span>
            <div className='flex w-full items-center gap-2'>
                {collapsedStart && <ProgressCollapsedDots className='bg-tertiary' />}
                {visibleCircles.map(({isFinished}, index) => (
                    <div key={index} className={twx('h-2 w-full', isFinished ? 'bg-tertiary' : 'bg-primary-dark-25')} />
                ))}
                {collapsedEnd && <ProgressCollapsedDots />}
            </div>
        </div>
    );
};
